import { useCallback, useMemo } from 'react'
import useAssets from '../../../hooks/useAssets'
import useSelectedGroupSatellite from '../../../hooks/useSelectedGroupSatellite'
import { TimelineEventTrack } from '../../../../../CommonComponents/timeline/Timeline'
import Event from '../Event'
import { ContactTaskSvg, NotContactTaskSvg } from '../../../../../CommonComponents/svgs/Svgs'
import ScheduleOverlay from './ScheduleOverlay'
import useOrbitAnimationDetails from '../../../hooks/useOrbitAnimationDetails'
import useTimelineFilter from '../../../hooks/useTimelineFilter'


const ScheduleEvents = () => {
    const { schedule } = useAssets()
    const { selectedGroupSatellite } = useSelectedGroupSatellite()
    const { filter } = useTimelineFilter()
    const { getViewerCurrentTime, orbitAnimationDetails, setAnimationStartTimeToViewer } = useOrbitAnimationDetails()

    const allAppliedFilters = useMemo(() => filter.flatMap(item => item.selectedOptions), [filter])
    const selectedSatellite = useMemo(() => selectedGroupSatellite?.satelliteId, [selectedGroupSatellite?.satelliteId])
    const scheduleEvents = useMemo(() => (selectedSatellite && schedule.data) ? schedule.data[selectedSatellite] || [] : [], [selectedSatellite, schedule.data])
    const filterdScheduleEvents = useMemo(() => scheduleEvents.filter((event) => {
        const status = event?.status
        const taskType = event?.type
        const taskName = event?.taskName
        const result = allAppliedFilters.includes(status) && allAppliedFilters.includes(taskType) && allAppliedFilters.includes(taskName)
        return allAppliedFilters?.length > 0 ? result : scheduleEvents
    }), [scheduleEvents, allAppliedFilters])

    const showAnimationDetails = useMemo(() => orbitAnimationDetails.showAnimationDetails, [orbitAnimationDetails.showAnimationDetails])

    const updateViewerStartTime = useCallback((startTime: number) => {
        if (!showAnimationDetails) return
        setAnimationStartTimeToViewer(startTime, selectedSatellite)
    }, [setAnimationStartTimeToViewer, showAnimationDetails])

    return (
        <TimelineEventTrack>
            {filterdScheduleEvents.map((event, index) => {
                const { startTime, endTime, taskName } = event
                const contactStatus = event?.status === 'Conflict' ? 'conflict' : event?.['status'] === 'Scheduled' ? 'scheduled' : 'not_scheduled'
                const contactType = event?.type
                const icon = contactType === 'Contact Task' ? <ContactTaskSvg /> : <NotContactTaskSvg />
                const currentTime = getViewerCurrentTime()
                const activeTask = startTime <= currentTime && endTime >= currentTime ? true : false
                const status = (activeTask && showAnimationDetails && event?.['status'] === 'Scheduled') ? 'ongoing' : contactStatus
                const uniqueid = `event-${index}-${startTime}-${endTime}-${taskName}`
                if (event?.status === 'Conflict') return null
                return (
                    <Event
                        key={uniqueid}
                        icon={icon}
                        endTime={endTime}
                        eventName={taskName}
                        startTime={startTime}
                        allEvents={filterdScheduleEvents}
                        className={status}
                        overlay={ScheduleOverlay}
                        onClick={() => { updateViewerStartTime(startTime) }}
                    />
                )
            })}
        </TimelineEventTrack>
    )
}

export default ScheduleEvents